import { Box, CircularProgress, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ImportStatus } from '@synergy/models';
import { PoolChip } from '@synergy/components';
import { Tooltip } from '@mui/material';
import { getImportStatusTranslationId } from '@synergy/utils';

import { ImportJob } from '../models/import-job';
import { ImportJobDetail } from '../models/import-job-detail';

interface ImportStatusChipProps {
    className?: string;
    importJob: ImportJobDetail | ImportJob;
    publishDate?: string;
}

const StyledSpinner = styled(CircularProgress)(({ theme }) => ({
    width: '13px !important',
    color: '#ffffff',
    height: '13px !important',
}));

export const ImportStatusChip = ({ importJob, className, publishDate }: ImportStatusChipProps) => {
    const getPublishDateOrState = (): React.ReactNode => {
        return publishDate && importJob.status === ImportStatus.Scheduled ? (
            <Box>{publishDate}</Box>
        ) : (
            <FormattedMessage id={getImportStatusTranslationId(importJob.status)} />
        );
    };

    return (
        <PoolChip
            status={importJob.status}
            listItem={true}
            className={className}
            label={
                importJob.processingFilesCount > 0 ? (
                    <Tooltip
                        title={
                            <FormattedMessage
                                id="app.imports.processingFilesToolTip"
                                values={{ processingFilesCount: importJob.processingFilesCount }}
                            />
                        }
                        placement="top"
                    >
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <StyledSpinner thickness={6} />
                            {getPublishDateOrState()}
                        </div>
                    </Tooltip>
                ) : (
                    getPublishDateOrState()
                )
            }
        />
    );
};
